import React from 'react';
import ReactECharts from 'echarts-for-react';
import { Theme } from '../../Styles/Theme';
import { ChartsCard } from './ChartsStyle';
import { getChartColors } from '../../../utils/chartColors';

const DEFAULT_X_LABELS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
const DEFAULT_SERIES = [
  { name: 'Completed', data: [140, 670, 170, 170, 290, 50, 100, 220, 480, 310, 190, 560, 90, 130] },
  { name: 'Reached', data: [150, 1000, 250, 250, 420, 80, 150, 350, 720, 480, 300, 800, 120, 200] },
];

const LineGraph = ({
  title = 'Line Graph',
  xLabels = DEFAULT_X_LABELS,
  series = DEFAULT_SERIES,
  yMax,
  yInterval,
  tooltipFormatter,
  chartHeight,
}) => {
  const colors = getChartColors('line', series.length);

  const getOption = () => {
    const { settings } = Theme;
    const hasDualAxis = series.some((s) => s.yAxisIndex === 1);
    const yAxisConfig = hasDualAxis
      ? [
          {
            type: 'value',
            min: 0,
            max: yMax,
            interval: yInterval,
            axisLine: { show: false },
            axisLabel: { color: settings.textColor },
            splitLine: { lineStyle: { type: 'dashed', color: settings.borderColor } },
          },
          {
            type: 'value',
            min: 0,
            axisLine: { show: false },
            axisLabel: { color: settings.textColor },
            splitLine: { show: false },
          },
        ]
      : {
          type: 'value',
          min: 0,
          max: yMax,
          interval: yInterval,
          axisLine: { show: false },
          axisLabel: { color: settings.textColor },
          splitLine: { lineStyle: { type: 'dashed', color: settings.borderColor } },
        };
    return {
      tooltip: {
        trigger: 'axis',
        backgroundColor: settings.whiteColor,
        borderColor: settings.borderColor,
        textStyle: { color: settings.tertiary },
        ...(tooltipFormatter ? { formatter: tooltipFormatter } : {}),
      },
      grid: {
        left: '3%',
        right: hasDualAxis ? '6%' : '4%',
        bottom: '15%',
        top: '12%',
        containLabel: true,
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: xLabels,
        axisLine: { lineStyle: { color: settings.borderColor } },
        axisLabel: { color: settings.textColor },
        splitLine: { show: true, lineStyle: { type: 'dashed', color: settings.borderColor } },
      },
      yAxis: yAxisConfig,
      legend: {
        data: series.map((s) => s.name),
        bottom: '2%',
        left: 'center',
        itemGap: 24,
        itemWidth: 10,
        itemHeight: 10,
        textStyle: { color: settings.tertiary, fontSize: 12 },
      },
      series: series.map((s, index) => ({
        name: s.name,
        type: 'line',
        smooth: true,
        symbol: 'circle',
        symbolSize: 6,
        data: s.data,
        yAxisIndex: s.yAxisIndex || 0,
        lineStyle: { color: s.color || colors[index], width: 2 },
        itemStyle: { color: s.color || colors[index] },
      })),
    };
  };

  return (
    <ChartsCard title={title}>
      <ReactECharts option={getOption()} style={{ width: '100%', height: chartHeight ? `${chartHeight}px` : '100%' }} />
    </ChartsCard>
  );
};

export default LineGraph;
